module.exports = __webpack_public_path__ + "img/feature-tile-icon-05.9b714925.svg";